import { render, staticRenderFns } from "./SerialNumbersList.vue?vue&type=template&id=2818e57b&scoped=true&"
import script from "./SerialNumbersList.vue?vue&type=script&lang=js&"
export * from "./SerialNumbersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818e57b",
  null
  
)

export default component.exports